import React, { useState } from 'react'
import NavBarHome from '../../../components/NavBar/NavBarHome'
import Footer from '../../../components/Footer/Footer'
import BlogHeader from './BlogHeader';
import BlogFeatured from './BlogFeatured';
import BlogCategories from './BlogCategories';
import BlogList from './BlogList';
import BlogNewsletter from './BlogNewsletter';

function Blog() {
   const [selected, setSelected] = useState("Tous");

   return (
      <div className="pt-[92px] flex flex-col min-h-screen">
         <NavBarHome />

         <BlogHeader />
         <BlogFeatured />
         <BlogCategories selected={selected} setSelected={setSelected} />
         <BlogList selected={selected} />
         <BlogNewsletter />

         <Footer
            logo={"/Logo NextMaker.png"}
            bgColor="bg-dark-1"
            textColor="text-gray-100"
            borderColor="border-gray-400/20"
         />
      </div>
   )
}

export default Blog